
import Intro from "../components/Intro";
import NavBar from "../components/NavBar";
import About from "../components/About";
import Experience from "../components/Experience";
import Services from "../components/Services";
import Contact from "../components/Contact";
import Tip from "../components/Tip";
import React, { useState } from 'react';


const Landing = () => {
  const [tip1Visible, setTip1Visible] = useState(true);
  return (
    <div>
      <Tip
       onClose={() => setTip1Visible(false)}
      visibility={tip1Visible}
        text={"💡 Tip: For better visibility, increase your screen brightness."}
        bottom={20}
        right={20}
      />
      <NavBar links={
        [
          {type:"scroll",to:"intro-section",label:"Home"},
           {type:"scroll",to:"about-section",label:"About"},
           { type: "anchor", label: "Certifications", href: "/Certifications" },
            {type:"scroll",to:"experience-section",label:"Experience"},
             {type:"scroll",to:"services-section",label:"Services"},
              { type: 'anchor', label: 'Projects', href: '',
                children: [
         { type: "anchor", label: "Dev Projects", href: "/DevProjects" },
{ type: "anchor", label: "IT Projects", href: "/ItProjects" }


      ],
               },
              { type: 'anchor', label: 'Products', href: '/Products' },
              {type:"scroll",to:"contact-section",label:"Contact"},

        ]
      } />
      <Intro />
      <About />
      <Experience />
      <Services />
      <Contact />
    </div>
  );
};

export default Landing;
